function arsenalInit(){
  // reference to add my other scripts
  // they are nested at the same levelhttp://gaby.dev.arsenalstudios.com/create-studio-main-site-2019/wp-content/themes/arsenal-bones/assets/scripts/arsenal-init.js?ver=1579017816
  const initScript = getScriptInfo('arsenal-init');
  const version = initScript.version ? "?ver="+initScript.version : "";
  
  addAsset(initScript.path +'arsenal-vendor.js'+version, addCustomScripts);

  function addCustomScripts(){
    addAsset(initScript.path+'arsenal-custom.js'+version);
  }
}

/***************************************************
  Document init
***************************************************/
// DOM Loaded
document.addEventListener("DOMContentLoaded",
  function() {
    arsenalInit();
  }
);